import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import { Paper } from '@material-ui/core';
import InfoBlock from '../../InfoBlock';

import useStyles from './styles';

const DATE_FORMAT = 'ddd D MMM, YYYY';

const formatRateQuantities = (rateQuantities) =>
  Object.entries(rateQuantities || {})
    .filter(([, count]) => count > 0)
    .map(([name, count]) => `${count} × ${name}`)
    .join(', ');

const TourInfo = ({ itinerary }) => {
  const classes = useStyles();

  const tour = itinerary.tour || {};
  const slot = itinerary.selectedSlot || {};
  const from = dayjs(itinerary.startDateTime);
  const to = dayjs(itinerary.endDateTime);
  const isSingleDay = from.isSame(to, 'day');
  const departure = [slot.time, slot.slotDescription].filter(Boolean).join(' · ');
  const travelers = formatRateQuantities(slot.rateQuantities);

  return (
    <>
      <div className="grid grid-cols-4 gap-1">
        <div className="row-start-1 row-end-3">
          {tour.primaryImageUrl ? (
            <img src={tour.primaryImageUrl} alt="IMG" />
          ) : (
            <Paper square classes={classes}>
              No photo
            </Paper>
          )}
        </div>
        <div className="col-start-2 col-end-5 truncate">{tour.name}</div>
        <div className="col-start-2 col-end-5 truncate">{tour.productType}</div>
      </div>
      <InfoBlock title="Tour details">
        <div className="grid grid-cols-2 text-sm">
          {isSingleDay ? (
            <>
              <div>Date:</div>
              <div>{from.format(DATE_FORMAT)}</div>
            </>
          ) : (
            <>
              <div>Trip start:</div>
              <div>{from.format(DATE_FORMAT)}</div>
              <div>Trip end:</div>
              <div>{to.format(DATE_FORMAT)}</div>
            </>
          )}
          {departure ? (
            <>
              <div>Departure:</div>
              <div>{departure}</div>
            </>
          ) : (
            ''
          )}
          {tour.durationText ? (
            <>
              <div>Duration:</div>
              <div>{tour.durationText}</div>
            </>
          ) : (
            ''
          )}
          {travelers ? (
            <>
              <div>Travelers:</div>
              <div>{travelers}</div>
            </>
          ) : (
            ''
          )}
          <div>Destination:</div>
          <div>{itinerary.destination}</div>
        </div>
      </InfoBlock>
    </>
  );
};

TourInfo.propTypes = {
  itinerary: PropTypes.shape().isRequired,
};

export default TourInfo;
